var $ff9177efc58547ad$exports = {};
$ff9177efc58547ad$exports = {
  "close": "\u0625\u063A\u0644\u0627\u0642",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " \u0625\u0634\u0639\u0627\u0631");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \u0625\u0634\u0639\u0627\u0631\u0627\u062A");
      }
    }), ".");
  }
};
export { $ff9177efc58547ad$exports as default };